import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import { ViewportList } from 'react-viewport-list';
import {
  AppContext,
  COMMON_CONSTANTS,
  EventEmitter,
  Loader,
  toast as niletoast
} from '@nile/components';
import ErrorToast from '@nile/components/src/Pages/SystemTrayChatPage/subpages/ChatBubble/ErrorToast';
import ChatEditor from '@nile/components/src/Pages/SystemTrayChatPage/ChatEditor';
import ChatHeader from '@nile/components/src/Pages/SystemTrayChatPage/ChatHeader';
import ChatBubble from '@nile/components/src/Pages/SystemTrayChatPage/subpages/ChatBubble';
import ChatTimer from '@nile/components/src/Pages/SystemTrayChatPage/ChatTimer';
import InfoText from '@nile/components/src/Pages/SystemTrayChatPage/subpages/ChatBubble/InfoMessage';
import ConnectionCheckerContainer from '@nile/home/src/ConnectionCheckerContainer';
import {
  closeChatAndPromptWindow,
  closeChatWindow,
  closePromptWindow,
  EVENT,
  NON_STORING_EVENTS,
  openChatWindow,
  postMessageToWails,
  SOURCE,
  SUBPAGE,
  WAILS_EVENT,
  killChatWindow
} from '@nile/components/src/Pages/SystemTrayChatPage/constants';
import {
  checkPingPongHeadRequest,
  connectAgentUserSocket
} from '@nile/home/public/workers/socketConnection';
import { isEmpty, omit } from 'lodash';
import { SystrayClient, TicketClient } from '@nile/graphql';
import nanoid from 'nanoid';
import {
  CREATE_CONVERSATION_THREAD,
  GET_ACTIVE_CONVERSATION_THREAD,
  GET_CONVERSATION,
  GET_CHAT_TEMPLATES,
  CLOSE_CONVERSATION_THREAD,
  GET_NEXT_ID,
  UPDATE_CONVERSATION_THREAD_INTITATOR_INFO
} from '@nile/components/src/Pages/SystemTrayChatPage/graphql';
import getUpdates from '@nile/components/src/Pages/SystemTrayChatPage/utils/getUpdates';
import { useIntl } from 'react-intl';
import {
  dompurifier,
  getTranslatedText
} from '@nile/components/src/Utils/helpers';
import { Slide, toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import envConfig from '@nile/home/src/Config/env';
import ScreenshotConfirmation from './subpages/ScreenshotConfirmation';
import { getHeaderContext } from './utils';
import ChangeSession from './subpages/ChangeSession';
import { getScreenshotAttachmentResp } from './helper';

let messageProcessing = false;
let chatNetworkDisconnected = false;
let threadActiveTimer;

function parseBoolean(string) {
  return string === 'true' ? true : string === 'false' ? false : undefined;
}

function SystemTrayFrameChatPage(props) {
  const {
    widthClassName,
    heightClassName,
    roundedBorder = false,
    data,
    eventData,
    source = null,
    chatData = null,
    setActiveChat = () => {},
    sendClientEvent,
    resumeChat = false,
    isOnDemandChatVersion
  } = props;

  const intl = useIntl();
  const isWeb = false; // this component loads on agent side only  // source === SOURCE.WEB;
  const CLIENT = isWeb ? TicketClient : SystrayClient;
  const agentProp = JSON.parse(sessionStorage.getItem('agentProperties'));
  const isAlpha =
    envConfig.mode === 'alpha' || envConfig.mode === 'development' || false;

  const appContext = useContext(AppContext);
  const { user: logginedinTech } = appContext;
  const params = new URLSearchParams(props.location.search);
  const isSessionConnected =
    parseBoolean(params.get('sessionConnected')) || false;
  const [customHeaders, setCustomHeaders] = useState({
    AssetId: eventData?.AssetId || agentProp?.AssetId,
    AssetToken: eventData?.AssetToken || agentProp?.AssetToken,
    AppAcc: eventData?.AppAcc || agentProp?.AppAcc,
    reqType: 'assetUser'
  });

  const [chatStatus, setChatStatus] = useState({
    sessionInitiated: false,
    sessionConnected: false,
    sessionClosed: false,
    screenCapture: false,
    sessionExpired: false
  });

  const [assetOffline, setAssetOffline] = useState(false);

  const [timerComponent, showTimerComponent] = useState(false);
  const [timerPopupData, setTimerPopupData] = useState({});
  const [userActiveConversation, setUserActiveConversation] = useState([]);
  const [conversation, setConversation] = useState([]);
  const [threadLoading, setThreadLoading] = useState(true);
  const [conversationTemplate, setConversationTemplate] = useState([]);
  const [conversationsLoading, setConversationLoading] = useState(true);
  const [messageCount, setMessageCount] = useState(0);
  const [lastMessageIndex, setLastMessageIndex] = useState(0);
  const [minimise, setMinimise] = useState(false);
  const [error, setError] = useState(null);
  const [isTyping, setTyping] = useState(false);
  const [closeProcessing, setCloseProcessing] = useState(false);
  const [tabVisible, setTabVisible] = useState(true);
  const [initialMessageProcessing, setInitialMessageProcessing] = useState(
    false
  );

  const viewPortRef = useRef(null);
  const chatRef = useRef({
    chatStatus: chatStatus,
    conversation: conversation,
    userActiveConversation: userActiveConversation,
    runTimer: localStorage.getItem('chatTimer'),
    lastIndex: lastMessageIndex
  });

  chatRef.current.chatStatus = chatStatus;
  chatRef.current.conversation = conversation;
  chatRef.current.userActiveConversation = userActiveConversation;
  chatRef.current.runTimer = localStorage.getItem('chatTimer');
  chatRef.current.lastIndex = lastMessageIndex;

  const initPrompt = (dta) => {
    postMessageToWails({
      eventName: WAILS_EVENT.INITIATE_PROMPT,
      data: {
        time: 3,
        width: 600,
        height: 250,
        title: 'Prompt',
        id: dta?.payload?.page?.component?.recordId,
        message: dta?.payload?.data?.conversation?.content || 'Test',
        techUser: JSON.stringify({
          name: dta?.payload?.data?.conversation?.data?.promptData?.user?.name,
          clientName:
            dta?.payload?.data?.conversation?.data?.promptData?.user
              ?.clienName || 'client'
        })
      }
    });
  };

  const getConversationTemplate = (convThread) => {
    TicketClient.query({
      query: GET_CHAT_TEMPLATES,
      variables: {
        input: {
          threadId: convThread
        }
      }
    }).then((res) => {
      setConversationTemplate(res?.data?.getChatTemplatesByConversationThread);
    });
  };

  const generateConversationId = () => {
    return CLIENT.query({
      query: GET_NEXT_ID,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      context: isWeb
        ? null
        : {
            headers: getHeaderContext(customHeaders, eventData)
          }
    });
  };

  const generateConversationThread = () => {
    if (chatData) {
      TicketClient.mutate({
        mutation: CREATE_CONVERSATION_THREAD,
        variables: {
          input: {
            asset: { assetId: chatData?.assetInfo?.assetId },
            workItem: {
              workId: data?.ticketId,
              module: data?.module
            },
            recipients: {
              receiver: [
                {
                  recipientType: 'RECEIVER',
                  referenceId: chatData?.loggedinUser?.userId,
                  name: chatData?.loggedinUser?.userName
                }
              ]
            }
          }
        }
      })
        .then((res) => {
          setError(null);
          if (res) {
            getConversationTemplate(
              res?.data?.createConversationThread?.threadId
            );
            setUserActiveConversation(res?.data?.createConversationThread);
          }
          setThreadLoading(false);
        })
        .catch((err) => setError(err));
    }
  };

  const focusLastAddedMessage = useCallback(() => {
    if (viewPortRef.current?.scrollHeight) {
      setTimeout(() => {
        viewPortRef.current.scrollTo({
          top: viewPortRef.current?.scrollHeight + 100,
          behavior: 'smooth'
        });
      }, 1);
    }
  }, [viewPortRef.current]);

  const getThreadConversations = (convData) => {
    CLIENT.query({
      query: GET_CONVERSATION,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      context: isWeb
        ? null
        : {
            headers: getHeaderContext(customHeaders, eventData)
          },
      variables: {
        input: {
          conversationThread: {
            threadId: convData?.threadId
          },
          listInfo: {
            pageSize: 500,
            page: 1,
            sort: [
              {
                attribute: 'time',
                order: 'ASC'
              }
            ],
            condition: null
          }
        }
      }
    })
      .then((res) => {
        setError(null);
        const resp = res?.data?.getConversations;
        let filteredResp;
        if (convData?.status === 'NOT_ACCEPTED') {
          const removeDuplicateRequesterNotAccepted = (conversations) => {
            const uniqueEvents = {};

            return conversations.filter((conv) => {
              if (
                conv?.type === 'EVENT' &&
                conv?.data?.action === 'REQUESTER_NOT_ACCEPTED'
              ) {
                const key = conv?.data?.action;
                if (!uniqueEvents[key]) {
                  uniqueEvents[key] = true;
                  return true;
                }
                return false;
              }
              return true;
            });
          };
          filteredResp = removeDuplicateRequesterNotAccepted(
            resp?.conversations
          )?.map((el) => ({
            ...el,
            isHttp: true
          }));
        } else {
          filteredResp = resp?.conversations
            ?.map((el) => ({
              ...el,
              isHttp: true
            }))
            ?.filter((el) => el?.type !== EVENT.EVENT);
        }
        updateConversationStatus(filteredResp);
        setConversation(filteredResp);
        if (isWeb && isEmpty(filteredResp)) {
          getConversationTemplate(convData?.threadId);
        }
      })
      .catch((err) => setError(err))
      .finally(() => {
        setThreadLoading(false);
        focusLastAddedMessage();
      });
  };

  const sendMessage = async (dataa) => {
    let dta = dataa;
    if (chatNetworkDisconnected) {
      console.log('Stop sending events when disconnected');
      return;
    }

    let nonStoringEvents = NON_STORING_EVENTS.WEB;
    if (!isWeb) {
      nonStoringEvents = [
        ...NON_STORING_EVENTS.WEB,
        ...NON_STORING_EVENTS.AGENT
      ];
    }

    const typingEvent =
      dta?.event === EVENT.TYPING_CONVERSATION ||
      dta?.event === EVENT.STOPPED_TYPING_CONVERSATION;
    const allConversation = chatRef.current.conversation;
    const chatState = chatRef.current.chatStatus;
    const userActiveConv = chatRef.current.userActiveConversation;

    if (
      isWeb &&
      !chatState?.sessionConnected &&
      !typingEvent &&
      !initialMessageProcessing
    ) {
      const techConv = allConversation?.some((el) => {
        return el?.isHttp
          ? el?.type === EVENT.TECH_REPLY
          : el?.data?.conversation?.type === EVENT.TECH_REPLY;
      });

      if ((isEmpty(allConversation) || !techConv) && dta?.message) {
        dta = { ...dta, event: EVENT.INITIATE_CONVERSATION };
      }
      setChatStatus((prevState) => ({
        ...prevState,
        sessionInitiated: true
      }));
      setInitialMessageProcessing(true);
      showTimerComponent(true);
    }
    const replyType = isWeb ? EVENT.TECH_REPLY : EVENT.REQ_REPLY;
    const conversationData =
      dta?.event === EVENT.INITIATE_CONVERSATION
        ? {
            promptData: {
              user: {
                name: logginedinTech?.user?.name,
                clienName: logginedinTech?.user?.site?.account?.name
              }
            }
          }
        : null;
    let convData = {
      connectionId: isWeb ? null : 'agentsocket',
      context: 'chat',
      type: dta?.type || !isWeb ? EVENT.AGENT_EVENT : EVENT.CLIENT_EVENT,
      id: !isWeb
        ? dta?.ticketId || userActiveConv?.workItem?.workId
        : data?.ticketId,
      threadId: dta?.threadId || userActiveConv?.threadId,
      data:
        dta?.data === null
          ? null
          : dta?.data || {
              conversation: {
                conversationId:
                  dta?.conversationId ||
                  dta?.conversation?.data?.conversationId ||
                  null,
                content: dta?.content ? dompurifier(dta?.content) : '',
                type: dta?.conversation?.data?.type
                  ? dta?.conversation?.data?.type
                  : replyType,
                attachments: dta?.attachments || null,
                conversationStatus:
                  dta?.conversation?.data?.conversationStatus || 'SENT',
                data: dta?.conversation?.data?.action
                  ? {
                      action: dta?.conversation?.data?.action
                    }
                  : conversationData
              }
            },
      epochMillis: dayjs()
        .utc()
        .valueOf(),
      event: dta?.event || EVENT.CONVERSATION_MESSAGE
    };

    if (dta?.conversationId || dta?.conversation?.data?.conversationId) {
      if (!typingEvent) {
        setConversation((prevState) => [...prevState, convData]);
        focusLastAddedMessage();
      }
      sendClientEvent({ isWeb, ...convData });

      if (sessionStorage.getItem('screenshotId')) {
        sessionStorage.removeItem('screenshotId');
      }
      return;
    }
    console.log('getting conversation id - isweb? ', isWeb);
    let isConvoApiFailed = false;
    await generateConversationId()
      .then(async (res) => {
        if (res) {
          convData = {
            ...convData,
            data: {
              ...convData?.data,
              conversation: {
                ...convData?.data?.conversation,
                conversationId: res?.data?.getNextIdentifier
              }
            }
          };
          setInitialMessageProcessing(false);
          sendClientEvent({ isWeb, ...convData });
        }
      })
      .catch(() => {
        niletoast('error', 'app.errorCode.20118');
        console.log('stop sending messages to chat bubble');
        isConvoApiFailed = true;
      });

    if (
      !typingEvent &&
      !initialMessageProcessing &&
      !nonStoringEvents.includes(dta?.conversation?.data?.action) &&
      !isConvoApiFailed
    ) {
      console.log('sending data to chat bubble');
      setConversation((prevState) => [...prevState, convData]);
      focusLastAddedMessage();
    }
  };
  const updateConversationStatus = (convs, socketMessage = false) => {
    const replyType = isWeb ? EVENT.REQ_REPLY : EVENT.TECH_REPLY;
    const unseenReplies = convs?.filter((el) =>
      socketMessage
        ? el?.data?.conversation?.type === replyType &&
          el?.data?.conversation?.conversationStatus === 'SENT'
        : el?.type === replyType && el?.conversationStatus === 'SENT'
    );
    const seenReplies = unseenReplies?.map((el) => {
      sendMessage({
        event: EVENT.UPDATE_CONVERSATION,
        conversation: {
          data: {
            conversationId: socketMessage
              ? el?.data?.conversation?.conversationId
              : el?.conversationId,
            conversationStatus: 'SEEN'
          }
        }
      });
    });
  };

  const clearChatData = () => {
    setUserActiveConversation([]);
    if (setActiveChat) setActiveChat(null);
    setConversation([]);
  };
  const closeWebChatWindow = () => {
    clearChatData();
    localStorage.removeItem('chatTimer');
    EventEmitter.dispatch('closeGlobalConversation', 'agentChatWindow');
  };

  const closeConversationThread = async ({
    convThread = userActiveConversation,
    closeTicket = false,
    createWorklog = false,
    ticket: ticketInput = {},
    worklog: worklogEntryInput = {},
    closeWindow = true
  }) => {
    let input = {
      conversationThread: {
        threadId: convThread?.threadId
      },
      createWorklog,
      closeTicket
    };

    if (createWorklog) {
      input = { ...input, worklogEntryInput };
    }
    if (closeTicket) {
      input = { ...input, ticketInput };
    }

    if (closeTicket && createWorklog) {
      input = {
        ...input,
        closeTicket,
        ticketInput,
        createWorklog,
        worklogEntryInput
      };
    }
    TicketClient.mutate({
      mutation: CLOSE_CONVERSATION_THREAD,
      variables: {
        input: input
      }
    })
      .then((res) => {
        if (res?.data?.closeConversationThread) {
          sendClientEvent({
            event: 'ENDED_CHAT',
            id: props?.data?.ticketId,
            entity: SUBPAGE.TICKET
          });
          sendClientEvent({
            event: 'ENDED_CHAT',
            id: chatData?.assetInfo?.assetId,
            entity: SUBPAGE.ASSET
          });
          setChatStatus({
            sessionInitiated: false,
            sessionConnected: false,
            sessionClosed: true,
            screenCapture: false,
            sessionExpired: false
          });
          if (closeWindow) {
            closeWebChatWindow();
          }
        }
      })
      .finally(() => {
        setCloseProcessing(false);
        setThreadLoading(false);
      });
  };

  const getConversationThreadInfo = () => {
    const agentProperties = JSON.parse(
      sessionStorage.getItem('agentProperties')
    );
    return CLIENT.query({
      query: GET_ACTIVE_CONVERSATION_THREAD,
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      context: isWeb
        ? null
        : {
            headers: getHeaderContext(customHeaders, eventData)
          },
      variables: isWeb
        ? null
        : {
            input: {
              asset: {
                assetId: customHeaders?.AssetId || agentProperties?.AssetId,
                referenceId: eventData?.UserId || agentProperties?.UserId
              }
            }
          }
    });
  };

  const getActiveConversationThread = ({
    sendSessionConnected = false,
    intiateThread = false
  } = {}) => {
    const agentProperties = JSON.parse(
      sessionStorage.getItem('agentProperties')
    );
    if (!isWeb) {
      const refId = customHeaders?.AssetId || agentProperties?.AssetId;
      if (isEmpty(refId)) {
        postMessageToWails({
          eventName: WAILS_EVENT.LOGGING,
          data: `Asset ID not available in session storage -> ${agentProperties?.AssetId}.`
        });
        return;
      }
    }
    setConversationLoading(true);
    postMessageToWails({
      eventName: WAILS_EVENT.LOGGING,
      data: `Getting conversation thread details, userId in session storage -> ${agentProperties?.UserId}.`
    });

    const convRes = getConversationThreadInfo();

    convRes
      .then(async (res) => {
        const resData = res?.data?.getActiveConversationThread;
        console.log('getconversationdata res ', resData);
        if (resData?.status === 'CONNECTED') {
          setChatStatus((prevState) => ({
            ...prevState,
            sessionConnected: true
          }));
          if (!isWeb) {
            openChatWindow();
          }
        } else if (resData?.status === 'INITIATED') {
          showTimerComponent(true);
          setChatStatus((prevState) => ({
            ...prevState,
            sessionInitiated: true
          }));
        } else if (resData?.status === 'CLOSED') {
          if (isWeb) {
            EventEmitter.dispatch('closeGlobalConversation', 'agentChatWindow');
          } else {
            isOnDemandChatVersion ? killChatWindow() : closeChatWindow();
          }
          return;
        } else if (resData?.status === 'NOT_ACCEPTED') {
          setChatStatus((prevState) => ({
            ...prevState,
            sessionConnected: false,
            sessionClosed: true
          }));
          isOnDemandChatVersion ? killChatWindow() : closeChatWindow();
        }
        if (!isEmpty(error)) setError(null);
        if (isWeb) {
          if (isEmpty(resData)) {
            generateConversationThread();
          } else {
            setUserActiveConversation(resData);
            getThreadConversations(resData);
            if (!resData?.chatActiveSession) {
              setMinimise(true);
            }
          }
        } else {
          if (!isEmpty(resData)) {
            setUserActiveConversation(resData);
            await getThreadConversations(resData);
            if (intiateThread) {
              if (threadActiveTimer) clearInterval(threadActiveTimer);
              threadActiveTimer = setInterval(() => {
                sendMessage({
                  event: 'CHAT_STATUS',
                  data: null,
                  ticketId: resData?.workItem?.workId,
                  threadId: resData?.threadId
                });
              }, 180000);
            }
            if (sendSessionConnected) {
              setChatStatus((prevState) => ({
                ...prevState,
                sessionInitiated: false,
                sessionConnected: true
              }));
              //temp fix
              setTimeout(function() {
                sendMessage({
                  type: EVENT.AGENT_EVENT,
                  event: EVENT.CONVERSATION_MESSAGE,
                  threadId: resData?.threadId,
                  conversation: {
                    data: {
                      type: EVENT.EVENT,
                      action: EVENT.SESSION_CONNECTED
                    }
                  }
                });
              }, 1000);
            }
          } else {
            setUserActiveConversation([]);
            setConversation([]);
            isOnDemandChatVersion
              ? killChatWindow()
              : closeChatWindow('EMPTY_DATA');
          }
          messageProcessing = false;
        }
      })
      .catch((err) => {
        console.log(err);
        niletoast('error', err);
        postMessageToWails({
          eventName: WAILS_EVENT.LOGGING,
          data: `FE - getActiveConversationThread API failed ${JSON.stringify(
            err
          )}. userId in session storage -> ${agentProperties?.UserId}.`
        });
      })
      .finally(() => {
        setConversationLoading(false);
        messageProcessing = false;
      });
  };

  const getConversationStartTime = () => {
    if (isEmpty(conversation)) {
      return null;
    }
    return conversation?.[0]?.time || conversation?.[0]?.epochMillis;
  };

  const changeSession = () => {
    if (userActiveConversation) {
      TicketClient.mutate({
        mutation: UPDATE_CONVERSATION_THREAD_INTITATOR_INFO,
        variables: {
          input: {
            threadId: userActiveConversation?.threadId
          }
        }
      }).then((res) => {
        if (res?.data?.updateConversationThreadInitiatorInfo) {
          getActiveConversationThread();
        }
      });
    }
  };

  const closeSession = ({
    convThread = userActiveConversation,
    worklog,
    ticket,
    closeTicket = false,
    createWorklog = false,
    closeWindow = true,
    closeOnlyWindow = false
  }) => {
    if (isWeb) {
      if (closeProcessing) return;
      setCloseProcessing(true);
      if (closeOnlyWindow) {
        closeWebChatWindow();
        return;
      }
      closeConversationThread({
        convThread,
        closeTicket,
        createWorklog,
        worklog,
        ticket,
        closeWindow
      });
      showTimerComponent(false);
    }
  };

  const checkForInitiate = (dta) => {
    if (isEmpty(chatRef?.current?.userActiveConversation)) {
      closeChatWindow();
      initPrompt(dta);
      return;
    }
    if (
      chatRef?.current?.userActiveConversation?.threadId ===
      dta?.payload?.page?.component?.recordId
    ) {
      return;
    }
    const convRes = getConversationThreadInfo();
    convRes.then((res) => {
      const resData = res?.data?.getActiveConversationThread;
      closeChatWindow();
      if (resData?.threadId === dta?.payload?.page?.component?.recordId) {
        clearChatData();
        initPrompt(dta);
      } else {
        sendMessage({
          type: EVENT.SERVER_EVENT,
          event: EVENT.INTERNAL_ERROR,
          data: {
            error: {
              message: `Incorrect start message received ${dta?.payload?.page?.component?.recordId} , Actual thread running is ${resData?.threadId}`
            }
          }
        });
      }
    });
  };

  const checkForCloseSession = (msg) => {
    if (
      chatRef?.current?.userActiveConversation?.threadId ===
        msg?.payload?.page?.component?.recordId ||
      isEmpty(chatRef?.current?.userActiveConversation)
    ) {
      if (chatStatus?.sessionInitiated) {
        isOnDemandChatVersion
          ? killChatWindow()
          : closePromptWindow(msg?.payload?.page?.component?.recordId);
      }
    } else {
      clearChatData();
      isOnDemandChatVersion ? killChatWindow() : closeChatWindow();
      sendMessage({
        type: EVENT.SERVER_EVENT,
        event: EVENT.INTERNAL_ERROR,
        data: {
          error: {
            message: `Incorrect close message received ${msg?.payload?.page?.component?.recordId} , Actual thread running is ${userActiveConversation?.threadId}`
          }
        }
      });
    }
  };

  const executeAgentFunctions = (msg) => {
    if (msg?.payload?.event === EVENT.INITIATE_CONVERSATION) {
      setChatStatus({
        sessionInitiated: true,
        sessionClosed: false,
        sessionConnected: false,
        screenCapture: false,
        sessionExpired: false
      });
      checkForInitiate(msg);
      return;
    }
    if (
      msg?.payload?.data?.conversation?.data?.action ===
      EVENT.REQUESTER_NOT_ACCEPTED
    ) {
      setUserActiveConversation([]);
      setConversation([]);
      setChatStatus({
        sessionInitiated: false,
        sessionConnected: false,
        sessionClosed: true,
        screenCapture: false,
        sessionExpired: false
      });
      setTimeout(() => {
        closeChatAndPromptWindow(
          msg?.payload?.page?.component?.recordId,
          isOnDemandChatVersion
        );
      }, 500);
    } else if (
      msg?.payload?.data?.conversation?.data?.action === EVENT.SESSION_CLOSED
    ) {
      setChatStatus({
        sessionInitiated: false,
        sessionClosed: true,
        sessionConnected: false,
        screenCapture: false,
        sessionExpired: false
      });
      checkForCloseSession(msg);
    } else if (
      msg?.payload?.data?.conversation?.data?.action ===
      EVENT.TECH_SCREENSHOT_REQUESTED
    ) {
      toast(
        <ScreenshotConfirmation
          sendMessage={sendMessage}
          generateConversationId={generateConversationId}
          threadData={chatRef?.current?.userActiveConversation}
          customHeaders={customHeaders}
          closeToastContainer={() => toast.dismiss()}
          intl={intl}
        />,
        {
          position: 'bottom-center',
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          closeButton: false,
          theme: 'light',
          transition: Slide
        }
      );
    }
  };

  const listenMessage = (msg) => {
    const conversationsRef = chatRef?.current?.conversation;
    const chatStatusRef = chatRef?.current?.chatStatus;

    if (!isWeb) {
      console.log('Socket message', msg);
    }
    let nonStoringEvents = NON_STORING_EVENTS.WEB;
    if (!isWeb) {
      nonStoringEvents = [
        ...NON_STORING_EVENTS.WEB,
        ...NON_STORING_EVENTS.AGENT
      ];
    }
    const currentEvent = msg?.payload?.event;
    const currentAction = msg?.payload?.data?.conversation?.data?.action;
    const convStatus = msg?.payload?.data?.conversation?.conversationStatus;
    const replyType = msg?.payload?.data?.conversation?.type;
    const statusEvent =
      currentEvent === EVENT.CHAT_STATUS ||
      currentEvent === EVENT.INTERNAL_ERROR;
    if (currentEvent === EVENT.TYPING_CONVERSATION) {
      setTyping(true);
      return;
    }
    if (currentEvent === EVENT.STOPPED_TYPING_CONVERSATION) {
      setTyping(false);
      return;
    }
    if (
      currentEvent === EVENT.CHAT_STATUS ||
      currentEvent === EVENT.INTERNAL_ERROR
    ) {
      if (!msg?.payload?.data?.chatActiveSession) {
        if (isWeb) {
          setMinimise(true);
          getActiveConversationThread();
        }
      }
      if (
        msg?.payload?.data?.status === 'INACTIVE' &&
        msg?.payload?.page?.component?.recordId ===
          userActiveConversation?.threadId
      ) {
        clearInterval(threadActiveTimer);
        if (!isWeb) {
          setTimeout(() => {
            closeChatAndPromptWindow(
              msg?.payload?.page?.component?.recordId,
              isOnDemandChatVersion
            );
          }, 500);
        } else {
          closeWebChatWindow();
        }
      }
    }
    if (currentAction === 'ASSET_OFFLINE') {
      if (assetOffline) return;
      setAssetOffline(true);
      setChatStatus((prevState) => ({ ...prevState, sessionClosed: true }));
    }
    if (currentAction === EVENT.REQUESTER_NOT_ACCEPTED) {
      if (chatStatusRef?.sessionClosed) return;
      showTimerComponent(false);
      localStorage.removeItem('chatTimer');
      setChatStatus((prevState) => ({ ...prevState, sessionClosed: true }));
      if (!isWeb) {
        executeAgentFunctions(msg);
        return;
      }
    }
    if (currentAction === EVENT.SESSION_CONNECTED) {
      showTimerComponent(false);
      localStorage.removeItem('chatTimer');
      setChatStatus((prevState) => ({
        ...prevState,
        sessionInitiated: false,
        sessionConnected: true
      }));
    }
    if (currentAction === 'ASSET_ONLINE' && chatStatusRef?.sessionConnected) {
      if (assetOffline) setAssetOffline(false);
      if (chatStatusRef?.sessionClosed)
        setChatStatus((prevState) => ({ ...prevState, sessionClosed: false }));
    }
    if (
      currentAction === EVENT.SCREENSHOT_TAKEN ||
      currentAction === EVENT.REQ_REJECTED_SCREENSHOT_REQUEST
    ) {
      messageProcessing = false;
      setChatStatus((prevState) => ({
        ...prevState,
        screenCapture: false
      }));
    }
    if (!isWeb) {
      executeAgentFunctions(msg);
    }
    if (
      convStatus === 'FAILED' ||
      (currentEvent === EVENT.UPDATE_CONVERSATION && convStatus === 'SEEN')
    ) {
      const indexToReplace = conversationsRef?.findIndex(
        (conv) =>
          conv?.data?.conversation?.conversationId ===
          msg?.payload?.data?.conversation?.conversationId
      );
      if (indexToReplace !== -1) {
        const updatedConv = [...conversationsRef];
        updatedConv.splice(indexToReplace, 1, {
          ...conversationsRef[indexToReplace],
          data: {
            ...conversationsRef[indexToReplace]?.data,
            conversation: {
              ...conversationsRef[indexToReplace]?.data?.conversation,
              conversationStatus:
                msg?.payload?.data?.conversation?.conversationStatus,
              failureReason:
                msg?.payload?.data?.conversation?.failureReason || null
            }
          }
        });
        setConversation(updatedConv);
      }
      return;
    }
    if (!nonStoringEvents.includes(currentAction)) {
      if (minimise) {
        setMessageCount((prevState) => prevState + 1);
      }
      if (!isWeb && chatStatusRef?.sessionConnected && !statusEvent) {
        postMessageToWails({
          eventName: WAILS_EVENT.NEW_MESSAGE
        });
      }

      if (tabVisible) {
        if (isWeb && !minimise && replyType === EVENT.REQ_REPLY) {
          sendMessage({
            event: EVENT.UPDATE_CONVERSATION,
            conversation: {
              data: {
                conversationId:
                  msg?.payload?.data?.conversation?.conversationId,
                conversationStatus: 'SEEN'
              }
            }
          });
        }
        if (!isWeb && replyType === EVENT.TECH_REPLY) {
          sendMessage({
            event: EVENT.UPDATE_CONVERSATION,
            conversation: {
              data: {
                conversationId:
                  msg?.payload?.data?.conversation?.conversationId,
                conversationStatus: 'SEEN'
              }
            }
          });
        }
      }

      // filter duplicate conversation ids
      const indexToReplace = conversationsRef?.findIndex(
        (conv) =>
          (conv?.conversationId || conv?.data?.conversation?.conversationId) ===
          msg?.payload?.data?.conversation?.conversationId
      );
      if (indexToReplace === -1) {
        // no it is new msg, update the state
        setConversation((prevState) => [...prevState, msg?.payload]);
        focusLastAddedMessage();
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (window.frameParentOrigin) {
        if (messageProcessing) return;
        if (
          event?.data?.data?.hasOwnProperty('notificationResponse') ||
          event?.data?.data?.hasOwnProperty('screenshotResponse')
        ) {
          messageProcessing = true;
        }
        const wailsEventData = event?.data?.data;
        try {
          /** notificationResponse to be removed in the next version */
          if (wailsEventData?.notificationResponse) {
            const resp = wailsEventData?.notificationResponse?.ErrorBool;
            if (!resp) {
              getConversationThreadInfo().then((res) => {
                if (res?.data?.getActiveConversationThread) {
                  const convData = res?.data?.getActiveConversationThread;
                  sendMessage({
                    type: EVENT.AGENT_EVENT,
                    event: EVENT.CONVERSATION_MESSAGE,
                    ticketId: convData?.workItem?.workId,
                    threadId: convData?.threadId,
                    conversation: {
                      data: {
                        type: EVENT.EVENT,
                        action: EVENT.REQUESTER_NOT_ACCEPTED
                      }
                    }
                  });
                  closeChatWindow();
                }
              });
              messageProcessing = false;
            } else {
              getActiveConversationThread({ sendSessionConnected: true });
            }
          }
          if (wailsEventData?.screenshotResponse) {
            const convID = sessionStorage.getItem('screenshotId');

            const isValidFormat = event?.data?.data?.isNewFormat || false;

            const { attachment, error } = getScreenshotAttachmentResp({
              data: event?.data?.data,
              validFormat: isValidFormat
            });
            if (!error) {
              sendMessage({
                type: EVENT.AGENT_EVENT,
                event: EVENT.CONVERSATION_MESSAGE,
                conversation: {
                  data: {
                    type: EVENT.EVENT,
                    action: EVENT.SCREENSHOT_TAKEN
                  }
                }
              });
              const parsedAttachment = (
                attachment?.data ||
                attachment ||
                []
              )?.map((el) => omit(el, ['downloadURL']));
              sendMessage({
                type: EVENT.AGENT_EVENT,
                event: EVENT.CONVERSATION_MESSAGE,
                conversationId: convID,
                attachments: parsedAttachment || []
              });
              setChatStatus((prevState) => ({
                ...prevState,
                screenCapture: false
              }));
              messageProcessing = false;
            } else {
              sessionStorage.removeItem('screenshotId');
              niletoast('error', ` ${error}`);
              messageProcessing = false;
            }
          }
          if (wailsEventData?.downloadRes) {
            const respErr = wailsEventData?.downloadRes?.DownloadFileError;
            if (isEmpty(respErr)) {
              niletoast(
                'success',
                `${getTranslatedText(intl, 'msp.chat.file.download.success')} ${
                  wailsEventData?.downloadRes?.DownloadFileName
                }`,
                'en',
                {},
                {
                  autoClose: 20000,
                  closeButton: true,
                  closeOnClick: false,
                  pauseOnHover: true,
                  draggable: false,
                  bodyClassName: 'wordBreakAll'
                }
              );
            } else {
              niletoast(
                'error',
                wailsEventData?.downloadRes?.DownloadFileError
              );
            }
          }
          if (wailsEventData?.conversationResponse) {
            if (wailsEventData?.conversationResponse?.context === 'chat') {
              listenMessage(wailsEventData?.conversationResponse);
            }
          }
          if (wailsEventData?.networkConnection) {
            console.log(
              'network disconnection event receieved ',
              wailsEventData?.networkConnection
            );
            if (wailsEventData?.networkConnection?.context === 'agentEvent') {
              if (
                wailsEventData?.networkConnection?.payload?.event ===
                'NETWORK_CONNECTED'
              ) {
                if (chatNetworkDisconnected) {
                  // reload the app when connected
                  window.location.reload();
                }
              }
              if (
                wailsEventData?.networkConnection?.payload?.event ===
                'NETWORK_DISCONNECTED'
              ) {
                chatNetworkDisconnected = true;
                niletoast('error', `msp.chat.offline`, null, null, {
                  autoClose: false
                });
              }
            }
          }
        } catch (err) {
          console.log(err, 'Err in processing wails message');
          postMessageToWails({
            eventName: WAILS_EVENT.LOGGING,
            data: `FE - Error while receiving wails message ${JSON.stringify(
              err
            )}`
          });
          messageProcessing = false;
        }
      }
    });
  }, []);

  useEffect(() => {
    if (customHeaders?.AssetToken) {
      getActiveConversationThread({
        intiateThread: !isSessionConnected,
        sendSessionConnected: isSessionConnected
      });
    }
  }, [customHeaders?.AssetToken]);

  useEffect(() => {
    if (!isWeb) {
      const agentProperties = JSON.parse(
        sessionStorage.getItem('agentProperties')
      );
      if (eventData?.AssetToken) {
        const assetEventData = {
          AssetId: eventData?.AssetId || agentProperties?.AssetId,
          AssetToken: eventData?.AssetToken || agentProperties?.AssetToken,
          AppAcc: eventData?.AppAcc || agentProperties?.AppAcc
        };
        setCustomHeaders((prevState) => ({
          ...prevState,
          ...assetEventData
        }));
      }
    }
  }, [eventData?.AssetToken]);

  useEffect(() => {
    if (!minimise) {
      updateConversationStatus(conversation.slice(lastMessageIndex), true);
      setMessageCount(0);
    } else {
      setLastMessageIndex(conversation?.length);
    }
  }, [minimise]);

  const checkForChat = () => {
    sendClientEvent({
      event: 'REGISTER_PAGE',
      id: chatData?.assetInfo?.assetId,
      entity: SUBPAGE.ASSET
    });
    sendClientEvent({
      event: 'STARTED_CHAT',
      id: props?.data?.ticketId,
      entity: SUBPAGE.TICKET,
      data: {
        assetInfo: {
          assetId: chatData?.assetInfo?.assetId,
          assetUserId: chatData?.loggedinUser?.userId
        }
      }
    });
    sendClientEvent({
      event: 'STARTED_CHAT',
      id: chatData?.assetInfo?.assetId,
      entity: SUBPAGE.ASSET
    });
    setTimeout(() => getActiveConversationThread(), 500);
  };

  useEffect(() => {
    if (resumeChat && isWeb) {
      checkForChat();
    }
  }, [resumeChat]);

  const handleVisibilityChange = () => {
    if (isWeb) {
      if (document.visibilityState === 'visible') {
        setTabVisible(true);
        updateConversationStatus(
          chatRef.current.conversation.slice(chatRef.current.lastIndex),
          true
        );
      } else {
        setTabVisible(false);
        setLastMessageIndex(chatRef.current.conversation?.length);
      }
    }
  };

  useEffect(() => {
    if (isWeb) {
      checkForChat();
      document.addEventListener('visibilitychange', handleVisibilityChange);
    } else {
      // checkPingPongHeadRequest();
    }
    return function cleanup() {
      document.removeEventListener('visibilityChange', handleVisibilityChange);
    };
  }, []);

  return (
    <ChatTimer
      timerPopupData={timerPopupData}
      handleWorklogCreated={closeSession}
      threadData={userActiveConversation}
      conversationStartTime={getConversationStartTime}
    >
      <div
        className={`${
          minimise ? 'full-height' : heightClassName || 'full-height'
        }  ${widthClassName ||
          'full-width'} bg-lvmist bshadow br10 position-relative`}
      >
        {conversationsLoading || threadLoading ? (
          <div className="flex-center ch-60">
            <Loader />
          </div>
        ) : (
          <>
            <ChatHeader
              isWeb={isWeb}
              chatSource={source}
              setMinimise={setMinimise}
              minimise={minimise}
              roundedBorder={roundedBorder}
              data={chatData}
              setTimerPopupData={setTimerPopupData}
              ticketData={data}
              threadData={userActiveConversation}
              chatStatus={chatStatus}
              setChatStatus={setChatStatus}
              sendMessage={sendMessage}
              closeSession={closeSession}
              threadLoading={threadLoading}
              messageCount={messageCount}
              clearChatData={clearChatData}
              isChooseTemplate={isEmpty(conversation)}
              isOnDemandChatVersion={isOnDemandChatVersion}
            />
            <div className={minimise ? 'hiddenActions' : 'full-height'}>
              <div
                className={`${
                  chatStatus?.sessionClosed ? 'ch-80' : 'ch-180'
                } scroll`}
                ref={viewPortRef}
              >
                <div>
                  {isEmpty(conversation) ? (
                    <>
                      {isWeb ? (
                        <>
                          {conversationTemplate?.map((item) => {
                            return (
                              <ChatBubble
                                logginedinTech={logginedinTech}
                                key={`index-${nanoid()}`}
                                data={{
                                  data: item,
                                  type: 'TEMPLATE',
                                  isHttp: true
                                }}
                                isCompact
                                sendMessage={sendMessage}
                                chatStatus={chatStatus}
                                setChatStatus={setChatStatus}
                                threadData={userActiveConversation}
                                allConversation={conversation}
                                customHeaders={customHeaders}
                                closeSession={closeSession}
                                isOnDemandChatVersion={isOnDemandChatVersion}
                              />
                            );
                          })}
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <>
                      <ViewportList
                        viewportRef={viewPortRef}
                        items={conversation}
                        margin={20}
                        initialOffset={20}
                        initialIndex={conversation.length - 1}
                        initialAlignToTop={false}
                      >
                        {(item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <ChatBubble
                                source={source}
                                key={`chat-${nanoid()}`}
                                data={item}
                                isCompact
                                chatStatus={chatStatus}
                                setChatStatus={setChatStatus}
                                sendMessage={sendMessage}
                                threadData={userActiveConversation}
                                allConversation={conversation}
                                customHeaders={customHeaders}
                                closeSession={closeSession}
                                clearChatData={clearChatData}
                                isOnDemandChatVersion={isOnDemandChatVersion}
                              />
                            </React.Fragment>
                          );
                        }}
                      </ViewportList>
                      {timerComponent && !minimise && (
                        <InfoText
                          timer
                          isWeb={isWeb}
                          sendMessage={sendMessage}
                          closeSession={closeSession}
                          setChatStatus={setChatStatus}
                          allConversation={conversation}
                          threadData={userActiveConversation}
                          chatStatus={chatRef.current.chatStatus}
                          minimise={minimise}
                          isOnDemandChatVersion={isOnDemandChatVersion}
                        />
                      )}
                    </>
                  )}
                </div>
              </div>
              <>
                {!chatStatus?.sessionClosed ? (
                  <>
                    {!isEmpty(error) ? (
                      <ErrorToast />
                    ) : (
                      <>
                        {isWeb ? (
                          <>
                            {userActiveConversation?.chatActiveSession ? (
                              <div>
                                <ChatEditor
                                  customHeaders={customHeaders}
                                  threadData={userActiveConversation}
                                  sendMessage={sendMessage}
                                  source={source}
                                  generateConversationId={
                                    generateConversationId
                                  }
                                  chatStatus={chatRef.current.chatStatus}
                                  setChatStatus={setChatStatus}
                                  isTyping={isTyping}
                                />
                              </div>
                            ) : (
                              <>
                                {userActiveConversation ? (
                                  <ChangeSession
                                    changeSession={changeSession}
                                  />
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <div>
                            <ChatEditor
                              customHeaders={customHeaders}
                              threadData={userActiveConversation}
                              sendMessage={sendMessage}
                              source={source}
                              generateConversationId={generateConversationId}
                              chatStatus={chatRef.current.chatStatus}
                              setChatStatus={setChatStatus}
                              isTyping={isTyping}
                            />
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            </div>
          </>
        )}
        {/* <ConnectionCheckerContainer origin="errorPage" /> */}
      </div>
    </ChatTimer>
  );
}

export default withRouter(SystemTrayFrameChatPage);
